import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { Task } from '../../types';
import { activityTypes } from 'bundles/apex/activities/type/config';


interface Props {
  task: Task;
}

export default function TaskType({ task }: Props) {
  const config = task.taskType && activityTypes[task.taskType as keyof typeof activityTypes];
  if (!config) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-1 text-muted">
      <FontAwesomeIcon icon={config.icon} size="sm" />
      <div>{config.label}</div>
    </div>
  );
}
